import { makeStyles } from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import OnOffByScroll from '../../../Animation/onOffByScroll';
import {
  seminarDeliveryInfoUpdate,
  seminarDeliveryInfoDetail,
  getInstructorActivePaymentMethods,
} from '../../../Apis/apiOfManaged';
import { localStorageArrayHandler } from '../../../CommonFunction/managePermission';
import { AuthContext } from '../../../auth';
import Footer from '../../../Footer/footer';
import various from '../../../General/various';
import BreadCrumbs from '../../../General/breadCrumbs';

const useStyles = makeStyles((theme) => ({
  pageTitle: {
    margin: '0px 0px 80px 0px',
    textAlign: 'start',
  },
  titles: {},
  inputs: {},
  helptext: {},
  error: {
    color: 'red',
    fontSize: '0.7em',
  },
  container: {
    marginTop: '168px',
    width: '100%',
    '& > form': {
      '& > div': {
        width: '70%',
        display: 'flex',
        margin: '0 auto',
        marginBottom: '32px',

        '& > div': {
          textAlign: 'start',
          display: 'flex',
          justifyContent: 'start',
          '& > img': {
            maxWidth: '300px',
            maxHeight: '300px',
            objectFit: 'contain',
          },
          '@media screen and (max-width:750px)': {
            width: '100%',
          },
        },

        '& $titles': {
          width: '30%',
          marginRight: '32px',
          '@media screen and (max-width:750px)': {
            width: '100%',
          },
          '& > label': {
            width: '100%',
            textAlign: 'end',
            '@media screen and (max-width:750px)': {
              textAlign: 'start',
              marginBottom: '16px',
            },
          },
          '& > span': {
            color: 'red',
          },
        },

        '& $inputs': {
          width: '70%',
          flexWrap: 'wrap',
          '@media screen and (max-width:750px)': {
            width: '100%',
          },
          '& > input, & > textarea, & > select': {
            width: '100%',
            height: '40px',
            padding: '8px',
            fontFamily: theme.typography.fontFamily,
            border: '0.5px solid grey',
            borderRadius: '0.5em',
            boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.1) inset',
            '&:focus': {
              outline: `1.2px ${theme.palette.primary.main} outset`,
            },
          },
          '& > textarea': {
            minHeight: '160px',
          },
          '& > input[type="checkbox"]': {
            boxShadow: 'none',
          },
          '& $helptext': {
            fontSize: '0.8rem',
            color: 'grey',
            '& > a': {
              textDecoration: 'underline',
              '&:link': {
                color: theme.palette.primary.main,
              },
            },
          },
        },
        '@media screen and (max-width:750px)': {
          flexWrap: 'wrap',
        },
      },
      '& > hr': {
        width: '100%',
        // 点線
        border: '0.5px dashed grey',
      },
    },
  },
  button: {
    width: '100%',
    marginTop: '88px !important',
    justifyContent: 'end',
    '& > button': {
      width: '100%',
      display: 'block',
      fontFamily: theme.typography.fontFamily,
      fontWeight: 'bold',
      borderRadius: '0.5em',
      border: 'none',
      padding: '4px 8px',
      backgroundColor: theme.palette.primary.main,
      boxShadow: '0px 0px 15px rgba(0,0,0,0.1)',
      color: '#fff',
      cursor: 'pointer',
    },
  },
}));

const SeminarDeliveryInfoUpdate = () => {
  const {
    register,
    reset,
    handleSubmit,
    watch,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    defaultValues: {},
  });

  const { isAuth } = useContext(AuthContext);
  const [deliveryInfo, setDeliveryInfo] = useState();
  const [instructorUuid, setInstructorUuid] = useState();
  const [instructorPaymentMethods, setInstructorPaymentMethods] = useState([]);
  const [hasPaymentAccounts, setHasPaymentAccounts] = useState(false);
  const [previous, setPrevious] = useState('');

  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyles();

  // クエリパラメータ取得
  const searchParams = new URLSearchParams(location.search);
  const uuid =
    (location.state && location.state.uuid) || searchParams.get('uuid'); // ← uuidキーの値を取得
  const permissions = localStorageArrayHandler('parse', various.permissionKey);

  const CRUMBS = [
    { name: '管理画面Top', path: '/manage/index' },
    { name: 'セミナー一覧', path: '/seminar_index' },
    { name: 'セミナー更新', path: '/seminar_delivery_info_update' },
  ];

  // if (deliveryInfo) console.log('deliveryInfo: ', deliveryInfo);
  // if (instructorUuid) console.log('instructorUuid: ', instructorUuid);
  // if (instructorPaymentMethods)
  //   console.log('instructorPaymentMethods: ', instructorPaymentMethods);
  // if (hasPaymentAccounts)
  //   console.log('hasPaymentAccounts: ', hasPaymentAccounts);
  // console.log('location.state.previous: ', location?.state?.previous);

  // Init
  useEffect(() => {
    if (location?.state?.previous) {
      setPrevious(location.state.previous);
    } else {
      // このケースはメールに記載のURLからインストラクターが遷移してきた場合 -> Submit後講師設定画面に遷移させる
      setPrevious(various.general.instructorSettingsForInstructor);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (uuid) {
      seminarDeliveryInfoDetail(setDeliveryInfo, uuid);
    }
  }, [uuid]);

  useEffect(() => {
    if (deliveryInfo) {
      // Form initialization
      const keys = Object.keys(deliveryInfo);
      const resetValues = {};

      function formatForDatetimeLocal(dt) {
        if (!dt) return '';
        // タイムゾーンを考慮せず、先頭16文字だけ抜き出す
        return dt.slice(0, 16);
      }

      const rejectList = ['seminar', 'instructor', 'created_at', 'updated_at'];

      keys.forEach((k) => {
        if (rejectList.includes(k)) return;
        if (k === 'start_at' || k === 'end_at') {
          resetValues[k] = formatForDatetimeLocal(deliveryInfo[k]);
        } else if (k === 'payment_accounts' && deliveryInfo[k]) {
          // payment_accountsの初期値設定
          resetValues.payment_accounts = {};
          Object.entries(deliveryInfo[k]).forEach(([type, value]) => {
            // valueが配列の場合（複数選択対応）: そのまま ／ valueがstringの場合（単一選択）: 配列化
            resetValues.payment_accounts[type] = Array.isArray(value)
              ? value
              : [value];
          });
        } else {
          resetValues[k] = deliveryInfo[k];
        }
      });
      // payment_accountsが空の場合、instructorPaymentMethodsのis_defaultなUUIDを初期値としてセット
      if (
        (!deliveryInfo.payment_accounts ||
          Object.keys(deliveryInfo.payment_accounts).length === 0) &&
        instructorPaymentMethods
      ) {
        // 銀行口座
        if (Array.isArray(instructorPaymentMethods.bank_accounts)) {
          const defaultBank = instructorPaymentMethods.bank_accounts.filter(
            (acc) => acc.is_active
          );
          if (defaultBank.length > 0) {
            resetValues['payment_accounts.bank'] = defaultBank.map(
              (acc) => acc.uuid
            );
          }
        }
        // PayPay口座
        if (Array.isArray(instructorPaymentMethods.paypay_accounts)) {
          const defaultPaypay = instructorPaymentMethods.paypay_accounts.filter(
            (acc) => acc.is_active
          );
          if (defaultPaypay.length > 0) {
            resetValues['payment_accounts.paypay'] = defaultPaypay.map(
              (acc) => acc.uuid
            );
          }
        }
        // Stripe Payment Links
        if (Array.isArray(instructorPaymentMethods.payment_links_accounts)) {
          const defaultLinks =
            instructorPaymentMethods.payment_links_accounts.filter(
              (acc) => acc.is_active
            );
          if (defaultLinks.length > 0) {
            resetValues['payment_accounts.paymentlinks'] = defaultLinks.map(
              (acc) => acc.uuid
            );
          }
        }
        // 他の決済種別があれば同様に追加
      }
      reset(resetValues);

      // Set instructorUuid
      if (deliveryInfo.instructor) {
        setInstructorUuid(deliveryInfo.instructor);
      }
    }
    // eslint-disable-next-line
  }, [deliveryInfo, instructorPaymentMethods, reset]);

  useEffect(() => {
    if (instructorUuid) {
      getInstructorActivePaymentMethods(
        setInstructorPaymentMethods,
        instructorUuid
      );
    }
  }, [instructorUuid]);

  useEffect(() => {
    if (
      instructorPaymentMethods &&
      instructorPaymentMethods.payment_types_available
    ) {
      const hasAccounts = Object.values(
        instructorPaymentMethods.payment_types_available
      ).some((v) => v === true);
      setHasPaymentAccounts(hasAccounts);
    }
  }, [instructorPaymentMethods]);

  // 決済方法の選択肢を生成
  const renderAccountCheckboxes = () => {
    if (!instructorPaymentMethods) return null;

    // 銀行口座
    const bankList = (instructorPaymentMethods.bank_accounts || [])
      .filter((acc) => acc.is_active)
      .map((acc) => (
        <label key={acc.uuid} style={{ marginRight: '24px' }}>
          <input
            type="checkbox"
            value={acc.uuid}
            {...register('payment_accounts.bank')}
          />
          {`銀行：${acc.bank_name}（${acc.branch_name}） / 名義人：${acc.account_holder}`}
        </label>
      ));

    // PayPay口座
    const paypayList = (instructorPaymentMethods.paypay_accounts || [])
      .filter((acc) => acc.is_active)
      .map((acc) => (
        <label key={acc.uuid} style={{ marginRight: '24px' }}>
          <input
            type="checkbox"
            value={acc.uuid}
            {...register('payment_accounts.paypay')}
          />
          {`PayPay：${acc.paypay_id}`}
        </label>
      ));

    // Stripe Payment Links
    const paymentLinksList = (
      instructorPaymentMethods.payment_links_accounts || []
    )
      .filter((acc) => acc.is_active)
      .map((acc) => (
        <label key={acc.uuid} style={{ marginRight: '24px' }}>
          <input
            type="checkbox"
            value={acc.uuid}
            {...register('payment_accounts.paymentlinks')}
          />
          {`Stripe Payment Links：${acc.amount.toLocaleString()}円`}
        </label>
      ));

    return (
      <>
        {bankList}
        {paypayList}
        {paymentLinksList}
      </>
    );
  };

  // Handler
  const handleAuth = () => {
    navigate(various.general.login, { state: { previous: location.pathname } });
  };

  // Submit
  const onSubmit = handleSubmit(async (data) => {
    // payment_accountsの空配列を除去
    if (data.payment_accounts) {
      Object.keys(data.payment_accounts).forEach((key) => {
        if (
          Array.isArray(data.payment_accounts[key]) &&
          data.payment_accounts[key].length === 0
        ) {
          delete data.payment_accounts[key];
        }
      });
      // payment_accounts自体が空になった場合はエラー
      if (Object.keys(data.payment_accounts).length === 0) {
        delete data.payment_accounts;
      }
    }
    // Accountsデータにおいて選択肢が一つであれば暗黙的に文字列としてここにくるので配列に変換する
    if (data.payment_accounts) {
      Object.keys(data.payment_accounts).forEach((key) => {
        if (typeof data.payment_accounts[key] === 'string') {
          data.payment_accounts[key] = [data.payment_accounts[key]];
        } else if (!Array.isArray(data.payment_accounts[key])) {
          data.payment_accounts[key] = [];
        }
      });
    }
    // console.log('送信データ: ', data);
    try {
      await seminarDeliveryInfoUpdate(data);
      console.log('update finish!');
      navigate(previous, {
        state: { previous: location.pathname, uuid: uuid },
      });
    } catch (error) {
      console.log(error);
    }
  });

  // Contents
  const form = () => {
    if (deliveryInfo) {
      return (
        <>
          <div className={classes.container}>
            <form
              method="POST"
              encType="multipart/form-data"
              onSubmit={onSubmit}
            >
              <div>
                <div className={classes.titles}>
                  <label htmlFor={'Platform'}>{'Platform'}</label>
                  <span> *</span>
                </div>
                <div className={classes.inputs}>
                  <input
                    id="platform"
                    type="text"
                    {...register('platform', {
                      required: { value: true, message: '入力必須の項目です' },
                    })}
                  />
                  {errors.platform?.message && (
                    <div className={classes.error}>
                      {errors.platform.message}
                    </div>
                  )}
                </div>
              </div>
              <div>
                <div className={classes.titles}>
                  <label htmlFor={'DeliveryUrl'}>{'DeliveryUrl'}</label>
                </div>
                <div className={classes.inputs}>
                  <input
                    id="delivery_url"
                    type="url"
                    {...register('delivery_url', {
                      required: { value: true, message: '入力必須の項目です' },
                    })}
                  />
                  <div className={classes.helptext}>
                    配信URLをご記載ください。なお、配信URLはセミナー公開前に必ずご登録ください。
                  </div>
                  {errors.delivery_url?.message && (
                    <div className={classes.error}>
                      {errors.delivery_url.message}
                    </div>
                  )}
                </div>
              </div>
              <div>
                <div className={classes.titles}>
                  <label htmlFor={'MeetingId'}>{'MeetingId'}</label>
                  <span> *</span>
                </div>
                <div className={classes.inputs}>
                  <input
                    id="meeting_id"
                    type="text"
                    {...register('meeting_id', {
                      required: { value: true, message: '入力必須の項目です' },
                    })}
                  />
                  <div className={classes.helptext}>
                    参加者に伝えるための「ミーティングID」をご記載ください。なお、ミーティングIDはセミナー公開前に必ずご登録ください。
                  </div>
                  {errors.meeting_id?.message && (
                    <div className={classes.error}>
                      {errors.meeting_id.message}
                    </div>
                  )}
                </div>
              </div>
              <div>
                <div className={classes.titles}>
                  <label htmlFor={'Password'}>{'Password'}</label>
                  <span> *</span>
                </div>
                <div className={classes.inputs}>
                  <input
                    id="password"
                    type="text"
                    {...register('password', {
                      required: { value: true, message: '入力必須の項目です' },
                    })}
                  />
                  <div className={classes.helptext}>
                    参加者に伝えるための「パスワード」をご記載ください。なお、パスワードはセミナー公開前に必ずご登録ください。
                  </div>
                  {errors.password?.message && (
                    <div className={classes.error}>
                      {errors.password.message}
                    </div>
                  )}
                </div>
              </div>
              <div>
                <div className={classes.titles}>
                  <label htmlFor={'StartAt'}>{'StartAt'}</label>
                  <span> *</span>
                </div>
                <div className={classes.inputs}>
                  <input
                    id="start_at"
                    type="datetime-local"
                    {...register('start_at', {
                      required: { value: true, message: '入力必須の項目です' },
                    })}
                  />
                  <div className={classes.helptext}>
                    セミナーの開始時刻と同じ日時がプリセットされていますが任意に書き換えてください。
                  </div>
                  {errors.start_at?.message && (
                    <div className={classes.error}>
                      {errors.start_at.message}
                    </div>
                  )}
                </div>
              </div>
              <div>
                <div className={classes.titles}>
                  <label htmlFor={'EndAt'}>{'EndAt'}</label>
                  <span> *</span>
                </div>
                <div className={classes.inputs}>
                  <input
                    id="end_at"
                    type="datetime-local"
                    {...register('end_at', {
                      required: { value: true, message: '入力必須の項目です' },
                    })}
                  />
                  <div className={classes.helptext}>
                    セミナーの開始時刻と同じ日時がプリセットされていますが任意に書き換えてください。
                  </div>
                  {errors.end_at?.message && (
                    <div className={classes.error}>{errors.end_at.message}</div>
                  )}
                </div>
              </div>
              <div>
                <div className={classes.titles}>
                  <label htmlFor={'Notes'}>{'Notes'}</label>
                  <span> *</span>
                </div>
                <div className={classes.inputs}>
                  <textarea
                    id="notes"
                    type="textarea"
                    {...register('notes', {
                      required: { value: true, message: '入力必須の項目です' },
                      maxLength: {
                        value: 2000,
                        message: '2000字以内でお願いします',
                      },
                    })}
                  />
                  <div className={classes.helptext}>
                    参加者に対する案内事項を2000字以内で記載してください。
                  </div>
                  {errors.notes?.message && (
                    <div className={classes.error}>{errors.notes.message}</div>
                  )}
                </div>
              </div>
              <div>
                <div className={classes.titles}>
                  <label htmlFor={'IsActive'}>{'IsActive'}</label>
                </div>
                <div className={classes.inputs}>
                  <input
                    id="is_active"
                    type="checkbox"
                    {...register('is_active', {
                      required: { value: false, message: '入力必須の項目です' },
                    })}
                  />
                  <div className={classes.helptext}>
                    OnLine配信を停止する場合はチェックを外してください。ただし、この制御は公開セミナー表記にのみ影響します。配信URLの無効化は別途行う必要があります。
                  </div>
                  {errors.is_active?.message && (
                    <div className={classes.error}>
                      {errors.is_active.message}
                    </div>
                  )}
                </div>
              </div>
              <hr />
              <p
                style={{
                  width: '70%',
                  display: 'flex',
                  textAlign: 'start',
                  margin: '0 auto',
                  fontSize: '0.9rem',
                }}
              >
                ■ オンライン参加者に伝える決済方法をご選択ください（複数可）
              </p>
              <div
                style={{
                  width: '70%',
                  display: 'flex',
                  flexWrap: 'wrap',
                  flexDirection: 'column',
                  justifyContent: 'start',
                  alignItems: 'start',
                  textAlign: 'start',
                  margin: '16px auto',
                  border: '1px solid #ccc',
                  padding: '16px',
                  borderRadius: '8px',
                  backgroundColor: '#f9f9f9',
                  fontSize: '0.95rem',
                }}
              >
                {renderAccountCheckboxes()}
              </div>
              <p
                style={{
                  width: '70%',
                  display: 'flex',
                  textAlign: 'start',
                  margin: '0 auto',
                  fontSize: '0.8rem',
                  marginBottom: '32px',
                  color: 'grey',
                }}
              >
                新規登録の場合はデフォルト設定の口座にチェックが入っています。更新時においては選択済みの口座にチェックが入っています。セミナー参加者の決済行動に必要な口座を任意にご選択ください。
              </p>
              {errors.payment_accounts?.message && (
                <div className={classes.error}>
                  {errors.payment_accounts.message}
                </div>
              )}
              <div className={classes.button}>
                <button type="submit">更新</button>
              </div>
            </form>
          </div>
        </>
      );
    }
  };

  // Validation
  const bank = watch('payment_accounts.bank');
  const paypay = watch('payment_accounts.paypay');
  const paymentLinks = watch('payment_accounts.paymentlinks');
  // 他の決済種別も同様にwatch

  function validateAtLeastOnePaymentAccount(accounts) {
    return Object.values(accounts).some(
      (v) => Array.isArray(v) && v.length > 0
    );
  }

  useEffect(() => {
    const accounts = { bank, paypay, paymentLinks /* 他も追加 */ };
    if (!validateAtLeastOnePaymentAccount(accounts)) {
      setError('payment_accounts', {
        type: 'manual',
        message: '決済方法を最低1つ選択してください',
      });
    } else {
      clearErrors('payment_accounts');
    }
  }, [bank, paypay, paymentLinks, setError, clearErrors]);

  return (
    <>
      <div style={{ margin: '80px' }}>
        <OnOffByScroll place="General" />
      </div>
      <div className={classes.pageTitle}>オンラインセミナー情報更新</div>
      <hr />
      <BreadCrumbs crumbs={CRUMBS} />
      {isAuth &&
      deliveryInfo &&
      (permissions.includes('admin') ||
        permissions.includes('instructor') ||
        permissions.includes('organizer')) ? (
        <>
          {hasPaymentAccounts ? (
            Object.keys(deliveryInfo).length > 0 ? (
              form()
            ) : (
              <div>コンテンツがありません</div>
            )
          ) : (
            <div>
              決済方法が登録されていません。セミナーの配信情報を更新する前に、講師の決済方法を登録してください。
              <span
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() =>
                  navigate(various.general.instructorPaymentMethodCreate, {
                    state: {
                      previous: location.pathname,
                      uuid: instructorUuid,
                      seminar_uuid: uuid, // セミナーのUUIDも渡す
                    },
                  })
                }
              >
                こちら
              </span>
              をクリックして登録してください。
            </div>
          )}
          <Footer />
        </>
      ) : (
        <div>
          <span
            style={{ cursor: 'pointer', textDecoration: 'underline' }}
            onClick={handleAuth}
          >
            ログイン
          </span>
          してください。
        </div>
      )}
    </>
  );
};
export default SeminarDeliveryInfoUpdate;
